// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","container":"PageWithSidebar__container--YL","main":"PageWithSidebar__main--Az SettingsSidebar__animation--IP"};